import {
  ArrayField,
  Controller,
  UseFieldArrayMethods,
  useFormContext,
} from 'react-hook-form';
import React from 'react';
import { get } from 'lodash';
import { PhysicalPerson } from '../../../../../../global/entities/Person';
import { PersonFieldInput } from '../person-field-input';
import { createFieldArrayInputName } from '../../../../../../utils/field-array/create-field-array-input-name';
import { RHFInputText } from '../../../../../../packages/react-hook-form';
import { useBuyProcessForm } from '../../../../buy-process-form-utils';
import { useDeleteBuyOrderRelation } from '../../../../../admin/buy-process/buy-order-edit/use-buy-order-edit';
import { DangerButton } from '../../../../../danger-button/danger-button';

export interface FieldArrayInputProps<T> {
  index: number;
  totalNumOfRepresentatives?: number;
  remove: UseFieldArrayMethods['remove'];
  field: Partial<ArrayField<T>>;
  fieldArrayName: string;
}

export const PhysicalPersonFieldInput = ({
  remove,
  field,
  index,
  fieldArrayName,
}: FieldArrayInputProps<PhysicalPerson>) => {
  const createName = (name: string) =>
    createFieldArrayInputName(fieldArrayName, index, name);

  const { numberShares, ...personInfo } = field;
  const { control, errors } = useFormContext();
  const { id } = useBuyProcessForm();

  const { handleRemoveRelation } = useDeleteBuyOrderRelation(
    id,
    get(field, 'relationId'),
  );

  return (
    <React.Fragment>
      <Controller
        as={<input hidden />}
        name={createName('relationId')}
        defaultValue={get(field, 'relationId') || ''}
        control={control}
      />

      <PersonFieldInput
        index={index}
        field={personInfo}
        fieldArrayName={fieldArrayName}
        extraFieldValues={{
          numberShares: 0,
        }}
      />

      <div
        style={{
          maxWidth: '150px',
          marginTop: '32px',
        }}
      >
        <RHFInputText
          required
          control={control}
          margin="dense"
          name={createName('numberShares')}
          errors={errors}
          label="Antal aktier"
          defaultValue={numberShares}
        />
      </div>

      <DangerButton
        onClick={() => {
          remove(index);
          handleRemoveRelation();
        }}
        style={{ alignSelf: 'flex-end', marginTop: '12px' }}
      >
        Radera Aktieägare
      </DangerButton>
    </React.Fragment>
  );
};
